/* Autogenerated file. Do not edit manually. */

import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { Overrides, Signer } from 'ethers';
import { Contract, ContractFactory, utils } from 'ethers';

import type {
  MogulMarketplace,
  MogulMarketplaceInterface,
} from '../MogulMarketplace';

const _abi = [
  {
    inputs: [
      { internalType: 'address', name: '_admin', type: 'address' },
      {
        internalType: 'address payable',
        name: '_treasuryWallet',
        type: 'address',
      },
      { internalType: 'address', name: '_mogulNFTAddress', type: 'address' },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'auctionId',
        type: 'uint256',
      },
    ],
    name: 'AuctionCancelled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'winner',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'auctionId',
        type: 'uint256',
      },
    ],
    name: 'AuctionClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'auctionId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'startingPrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'startTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'endTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reservePrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'auctionToken',
        type: 'address',
      },
    ],
    name: 'AuctionCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'auctionId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newReservePrice',
        type: 'uint256',
      },
    ],
    name: 'AuctionReservePriceChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'bidder',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'auctionId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'auctionToken',
        type: 'address',
      },
    ],
    name: 'BidPlaced',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'listingId',
        type: 'uint256',
      },
    ],
    name: 'ListingCancelled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'listingId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'listingPrices',
        type: 'uint256[]',
      },
      {
        indexed: false,
        internalType: 'address[]',
        name: 'listingTokens',
        type: 'address[]',
      },
    ],
    name: 'ListingCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'listingId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'newPrice',
        type: 'uint256[]',
      },
    ],
    name: 'ListingPriceChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'newAdminRole',
        type: 'bytes32',
      },
    ],
    name: 'RoleAdminChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleGranted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleRevoked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'buyer',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'listingId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'purchaseToken',
        type: 'address',
      },
    ],
    name: 'SaleMade',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newTokenCashBackBasisPoint',
        type: 'uint256',
      },
    ],
    name: 'TokenCashBackBasisPointSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'tokenIds',
        type: 'uint256[]',
      },
      {
        indexed: false,
        internalType: 'address payable[]',
        name: 'artistAddresses',
        type: 'address[]',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'commissionBasisPoints',
        type: 'uint256[]',
      },
    ],
    name: 'TokenCommissionBulkAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'artistAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'commissionBasisPoint',
        type: 'uint256',
      },
    ],
    name: 'TokenCommissionSingleAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newTokenFeeBasisPoint',
        type: 'uint256',
      },
    ],
    name: 'TokenFeeBasisPointSet',
    type: 'event',
  },
  {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ROLE_ADMIN',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_mogulNFTAddress', type: 'address' },
    ],
    name: 'addMogulNFTAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'auctions',
    outputs: [
      { internalType: 'address payable', name: 'seller', type: 'address' },
      { internalType: 'address', name: 'tokenAddress', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
      { internalType: 'uint256', name: 'tokenAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'startingPrice', type: 'uint256' },
      { internalType: 'uint256', name: 'startTime', type: 'uint256' },
      { internalType: 'uint256', name: 'endTime', type: 'uint256' },
      { internalType: 'uint256', name: 'reservePrice', type: 'uint256' },
      { internalType: 'address', name: 'auctionToken', type: 'address' },
      {
        components: [
          { internalType: 'address payable', name: 'bidder', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        internalType: 'struct MogulMarketplaceERC1155.Bid',
        name: 'highestBid',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256[]', name: '_auctionIds', type: 'uint256[]' },
    ],
    name: 'batchCancelAuction',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256[]', name: '_listingIds', type: 'uint256[]' },
    ],
    name: 'batchCancelListing',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256[]', name: '_auctionIds', type: 'uint256[]' },
    ],
    name: 'batchClaimAuction',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address[]', name: 'tokenAddresses', type: 'address[]' },
      { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'tokenAmounts', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'startingPrices', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'startTimes', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'endTimes', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'reservePrices', type: 'uint256[]' },
      { internalType: 'address[]', name: 'auctionTokens', type: 'address[]' },
    ],
    name: 'batchCreateAuctions',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address[]', name: 'tokenAddresses', type: 'address[]' },
      { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'tokenAmounts', type: 'uint256[]' },
      {
        internalType: 'uint256[][]',
        name: 'listingPrices',
        type: 'uint256[][]',
      },
      {
        internalType: 'address[][]',
        name: 'listingTokens',
        type: 'address[][]',
      },
    ],
    name: 'batchCreateListings',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'listingId', type: 'uint256' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'expectedPrice', type: 'uint256' },
      { internalType: 'address', name: 'purchaseToken', type: 'address' },
    ],
    name: 'buyTokens',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'auctionId', type: 'uint256' }],
    name: 'cancelAuction',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'listingId', type: 'uint256' }],
    name: 'cancelListing',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'listingId', type: 'uint256' },
      { internalType: 'uint256[]', name: 'newPrice', type: 'uint256[]' },
    ],
    name: 'changeListingPrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'auctionId', type: 'uint256' },
      { internalType: 'uint256', name: 'newReservePrice', type: 'uint256' },
    ],
    name: 'changeReservePrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'auctionId', type: 'uint256' }],
    name: 'claimAuction',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'uint256', name: '', type: 'uint256' },
    ],
    name: 'commissions',
    outputs: [
      {
        internalType: 'address payable',
        name: 'artistAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'commissionBasisPoint',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'tokenAddress', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
      { internalType: 'uint256', name: 'tokenAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'startingPrice', type: 'uint256' },
      { internalType: 'uint256', name: 'startTime', type: 'uint256' },
      { internalType: 'uint256', name: 'endTime', type: 'uint256' },
      { internalType: 'uint256', name: 'reservePrice', type: 'uint256' },
      { internalType: 'address', name: 'auctionToken', type: 'address' },
    ],
    name: 'createAuction',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'tokenAddress', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
      { internalType: 'uint256', name: 'tokenAmount', type: 'uint256' },
      { internalType: 'uint256[]', name: 'listingPrices', type: 'uint256[]' },
      { internalType: 'address[]', name: 'listingTokens', type: 'address[]' },
    ],
    name: 'createListing',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'depositTokenForCashBack',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256[]', name: 'indices', type: 'uint256[]' }],
    name: 'getAuctionIds',
    outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256[]', name: 'indices', type: 'uint256[]' }],
    name: 'getAuctionsAtIndices',
    outputs: [
      {
        components: [
          { internalType: 'address payable', name: 'seller', type: 'address' },
          { internalType: 'address', name: 'tokenAddress', type: 'address' },
          { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
          { internalType: 'uint256', name: 'tokenAmount', type: 'uint256' },
          { internalType: 'uint256', name: 'startingPrice', type: 'uint256' },
          { internalType: 'uint256', name: 'startTime', type: 'uint256' },
          { internalType: 'uint256', name: 'endTime', type: 'uint256' },
          { internalType: 'uint256', name: 'reservePrice', type: 'uint256' },
          { internalType: 'address', name: 'auctionToken', type: 'address' },
          {
            components: [
              {
                internalType: 'address payable',
                name: 'bidder',
                type: 'address',
              },
              { internalType: 'uint256', name: 'amount', type: 'uint256' },
            ],
            internalType: 'struct MogulMarketplaceERC1155.Bid',
            name: 'highestBid',
            type: 'tuple',
          },
        ],
        internalType: 'struct MogulMarketplaceERC1155.Auction[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'NFTAddress', type: 'address' },
      { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
    ],
    name: 'getCommissionInfoForTokens',
    outputs: [
      {
        components: [
          {
            internalType: 'address payable',
            name: 'artistAddress',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'commissionBasisPoint',
            type: 'uint256',
          },
        ],
        internalType: 'struct MogulMarketplaceERC1155.TokenCommissionInfo[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256[]', name: 'indices', type: 'uint256[]' }],
    name: 'getListingIds',
    outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256[]', name: 'indices', type: 'uint256[]' }],
    name: 'getListingsAtIndices',
    outputs: [
      {
        components: [
          { internalType: 'address payable', name: 'seller', type: 'address' },
          { internalType: 'address', name: 'tokenAddress', type: 'address' },
          { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
          { internalType: 'uint256', name: 'tokenAmount', type: 'uint256' },
          {
            internalType: 'uint256[]',
            name: 'listingPrices',
            type: 'uint256[]',
          },
          {
            internalType: 'address[]',
            name: 'listingTokens',
            type: 'address[]',
          },
        ],
        internalType: 'struct MogulMarketplaceERC1155.Listing[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getNumAuctions',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getNumListings',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
    name: 'getRoleAdmin',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'hasRole',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'id', type: 'uint256' }],
    name: 'listings',
    outputs: [
      {
        components: [
          { internalType: 'address payable', name: 'seller', type: 'address' },
          { internalType: 'address', name: 'tokenAddress', type: 'address' },
          { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
          { internalType: 'uint256', name: 'tokenAmount', type: 'uint256' },
          {
            internalType: 'uint256[]',
            name: 'listingPrices',
            type: 'uint256[]',
          },
          {
            internalType: 'address[]',
            name: 'listingTokens',
            type: 'address[]',
          },
        ],
        internalType: 'struct MogulMarketplaceERC1155.Listing',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nextAuctionId',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nextListingId',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'uint256[]', name: '', type: 'uint256[]' },
      { internalType: 'uint256[]', name: '', type: 'uint256[]' },
      { internalType: 'bytes', name: '', type: 'bytes' },
    ],
    name: 'onERC1155BatchReceived',
    outputs: [{ internalType: 'bytes4', name: '', type: 'bytes4' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'bytes', name: '', type: 'bytes' },
    ],
    name: 'onERC1155Received',
    outputs: [{ internalType: 'bytes4', name: '', type: 'bytes4' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'auctionId', type: 'uint256' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'placeBid',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_mogulNFTAddress', type: 'address' },
    ],
    name: 'removeMogulNFTAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'NFTAddress', type: 'address' },
      { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
      {
        internalType: 'address payable',
        name: 'artistAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'commissionBasisPoint',
        type: 'uint256',
      },
    ],
    name: 'setCommission',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'NFTAddress', type: 'address' },
      { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
      {
        internalType: 'address payable[]',
        name: 'artistAddresses',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: 'commissionBasisPoints',
        type: 'uint256[]',
      },
    ],
    name: 'setCommissionBulk',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'bool', name: '_allowed', type: 'bool' },
    ],
    name: 'setTokenAllowed',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: '_cashBackBasisPoint', type: 'uint256' },
    ],
    name: 'setTokenCashBack',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: '_feeBasisPoint', type: 'uint256' },
    ],
    name: 'setTokenFee',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'tokenInfo',
    outputs: [
      { internalType: 'bool', name: 'allowed', type: 'bool' },
      { internalType: 'uint256', name: 'feeBasisPoint', type: 'uint256' },
      { internalType: 'uint256', name: 'cashBackBasisPoint', type: 'uint256' },
      {
        internalType: 'uint256',
        name: 'availableForCashBack',
        type: 'uint256',
      },
      { internalType: 'uint256', name: 'balanceForAdmin', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'treasuryWallet',
    outputs: [{ internalType: 'address payable', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'withdrawToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'withdrawTokenForCashBack',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

export class MogulMarketplaceFactory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    starsAddress: string,
    _admin: string,
    _treasuryWallet: string,
    _mogulNFTAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<MogulMarketplace> {
    return super.deploy(
      starsAddress,
      _admin,
      _treasuryWallet,
      _mogulNFTAddress,
      overrides ?? {},
    ) as Promise<MogulMarketplace>;
  }
  getDeployTransaction(
    starsAddress: string,
    _admin: string,
    _treasuryWallet: string,
    _mogulNFTAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(
      starsAddress,
      _admin,
      _treasuryWallet,
      _mogulNFTAddress,
      overrides ?? {},
    );
  }
  attach(address: string): MogulMarketplace {
    return super.attach(address) as MogulMarketplace;
  }
  connect(signer: Signer): MogulMarketplaceFactory {
    return super.connect(signer) as MogulMarketplaceFactory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MogulMarketplaceInterface {
    return new utils.Interface(_abi) as MogulMarketplaceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): MogulMarketplace {
    return new Contract(address, _abi, signerOrProvider) as MogulMarketplace;
  }
}
